import { jsx as _jsx } from "react/jsx-runtime";
const DifficultyIcon = (props) => {
    return (_jsx("svg", Object.assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { id: "Vector", d: "M7.5 14.1667H5.83333V10.8333H7.5V14.1667ZM10.8333 14.1667H9.16667V8.33333H10.8333V14.1667ZM14.1667 14.1667H12.5V5.83333H14.1667V14.1667ZM15.8333 15.8333H4.16667V4.16667H15.8333V15.9167M15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5Z", fill: props.color }) })));
};
DifficultyIcon.defaultProps = {
    color: 'white',
};
export default DifficultyIcon;
